import type { PublicKeyCredentialRequestOptionsJSON } from "@simplewebauthn/server";
import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    name: z.string(),
    bic: z.string(),
    iban: z.string(),
  }),
  response: z.object({
    webAuthnAuthenticationOptions: z.custom<PublicKeyCredentialRequestOptionsJSON>(),
  }),
};
